module.exports = __webpack_public_path__ + "447ec99a9444402a24d9d0b1a96ee570.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/Slider/images/image4.png
// module id = zSYR
// module chunks = 0